<template>
  <div class="pro-user-info">
    <el-row type="flex" justify="space-between">
      <span style="font-weight: bold; font-size: 1.2em;">人员资料</span>
      <el-button plain @click="$emit('update:modelValue')" icon="back">返回</el-button>
    </el-row>

    <el-tabs v-model="activeName" class="demo-tabs">
      <el-tab-pane label="基本信息" name="base"><base-info :user="user" /></el-tab-pane>
      <el-tab-pane label="工资信息" name="wage" lazy><wage :user="user" /></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BaseInfo from './BaseInfo.vue';
import Wage from './Wage.vue';

export default defineComponent({
  components: { BaseInfo, Wage },
  emits: ['update:modelValue'],
  props: {
    user: Object,
    modelValue: Boolean
  },
  data() {
    return {
      activeName: 'base'
    }
  }
})
</script>

<style lang="scss" scoped>
.pro-user-info {
  padding: 20px;
}
</style>
